function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var MainTemplate = require('./main.template');
var Dashboard = require('./dashboard');
var BlockTeaser = require('./block-teaser');
var TransactionTeaser = require('./transaction-teaser');
var Main = /*#__PURE__*/function () {
  function Main(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.explorer-view';
    _classCallCheck(this, Main);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.dashboard = new Dashboard(app, mod);
    this.blockTeaser = new BlockTeaser(app, mod);
    this.transactionTeaser = new TransactionTeaser(app, mod);
  }
  return _createClass(Main, [{
    key: "render",
    value: function render() {
      var _this = this;
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      this.app.browser.replaceElementContentBySelector(MainTemplate(), this.container);
      this.dashboard.render("".concat(this.container, " .explorer-dashboard"));
      this.blockTeaser.render("".concat(this.container, " .block-teaser"));
      this.transactionTeaser.render("".concat(this.container, " .transaction-teaser"));
      var refreshButton = document.querySelector("".concat(this.container, " [data-explorer-refresh]"));
      if (refreshButton) {
        refreshButton.onclick = function () {
          return _this.mod.refreshHomeData();
        };
      }
    }
  }]);
}();
module.exports = Main;